import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      STREET_NUMBER_LABEL: "Gatenummer",
    },

    se: {
      STREET_NUMBER_LABEL: "Gatunummer",
    },

    dk: {
      STREET_NUMBER_LABEL: "Gadenummer",
    },
  } as const
)[language];
